import type { FC } from 'react';

import ValueWithDefault from '@zen/Components/ValueWithDefault';
import { SkeletonLoading } from '@zen/DesignSystem';

import type { ScopeCountProps } from './types';

const ScopeCount: FC<ScopeCountProps> = ({ count, isLoading }) => {
  if (isLoading) {
    return (
      <div className="-mx-2 h-6 py-0.5" data-component="scope-count">
        <SkeletonLoading lighter={true} width="w-12" />
      </div>
    );
  }

  return (
    <div className="text-xl font-bold leading-6 text-navy-base" data-component="scope-count">
      <ValueWithDefault value={count} />
    </div>
  );
};

export default ScopeCount;
